import { initCartConflictDrawer } from './cart-conflict';
import { syncStoreLocatorLabels } from './labels';
import { clearDeliverySelection, openDeliverySelector } from './delivery-selector';
import { openShopSelector } from './shop-selector';

function bindHeaderTriggers() {
  const defaultsElement = document.querySelector('[data-store-locator-defaults]');

  if (!defaultsElement) return;

  const shopTrigger = document.querySelector('.js-store-locator-shop-trigger:not([data-getting-your-order-trigger])');
  const deliveryTrigger = document.querySelector('.js-store-locator-delivery-trigger:not([data-getting-your-order-trigger])');

  shopTrigger?.addEventListener('click', () => {
    openShopSelector(shopTrigger);
  });

  deliveryTrigger?.addEventListener('click', () => {
    openDeliverySelector(deliveryTrigger);
  });
}

function bindGettingYourOrderTriggers() {
  if (document.documentElement.dataset.storeLocatorPdpTriggersInit) return;

  document.documentElement.dataset.storeLocatorPdpTriggersInit = 'true';

  document.addEventListener('click', (event) => {
    const block = event.target.closest('[data-getting-your-order]');
    if (!block) return;

    const shopTrigger = event.target.closest('.js-getting-your-order-shop-trigger');
    const deliveryTrigger = event.target.closest('.js-getting-your-order-delivery-trigger');
    const clearDeliveryTrigger = event.target.closest('.js-getting-your-order-delivery-clear');

    if (shopTrigger) {
      event.preventDefault();
      const dataScript = block.querySelector('.js-getting-your-order-data');
      let variantData = null;

      if (dataScript?.textContent) {
        try {
          variantData = JSON.parse(dataScript.textContent);
        } catch {
          variantData = null;
        }
      }

      openShopSelector(shopTrigger, { variantData });
      return;
    }

    if (deliveryTrigger) {
      event.preventDefault();
      openDeliverySelector(deliveryTrigger);
      return;
    }

    if (clearDeliveryTrigger) {
      event.preventDefault();
      clearDeliverySelection();
    }
  });
}

function initStoreLocator() {
  initCartConflictDrawer();
  syncStoreLocatorLabels();
  bindHeaderTriggers();
  bindGettingYourOrderTriggers();
}

export default function storeLocator() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoreLocator);
    return;
  }

  initStoreLocator();
}

export { openDeliverySelector, openShopSelector, clearDeliverySelection };
